import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CCodeComponent } from './ccode.component';
import { CCodeSelectedComponent } from './ccode-selected/ccode-selected.component';

@NgModule({
  declarations: [
    CCodeComponent,
    CCodeSelectedComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
  ],
  exports: [
    CCodeComponent
  ]
})
export class CCodeModule {}
